<div
  class="row-details entity-item clickable"
  [ngClass]="{ 'first-item': firstItem, 'last-item': lastItem }"
  (click)="rowClicked()"
  >
  <div class="entity-marked" [ngClass]="{ selected: isSelected }">&nbsp;</div>
  <div class="entity-name overflow-ellipsis" [innerHTML]="entity.name | highlightSearch:qsWord"></div>
  @if (entity.withExploit) {
    <div class="entity-status">
      <div
        class="highlighting"
        [ngClass]="entity.exploitClass"
        [innerHTML]="entity.exploitKey | translate"
      ></div>
    </div>
  }
</div>
